export default "__VITE_ASSET__02e42cd1__"